var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, Spacer } from 'shared/components/ui';
import { SubNavTab } from './subNavTab';
/**
 *  A sub-navigation component that looks like a tab bar
 * @param {object} items - The items to display in the subnav
 * @returns {React.ReactNode}
 */
var SubNav = function (_a) {
    var items = _a.items, actions = _a.actions, props = __rest(_a, ["items", "actions"]);
    /**
     * Render the component
     */
    return (_jsxs(Flex, __assign({ h: 12, borderBottomColor: 'gray.300', borderBottomWidth: 1 }, props, { "data-testid": "sub-nav" }, { children: [items &&
                items.map(function (item, idx) { return (_jsx(SubNavTab, { text: item.text, url: item.url, isActive: item.isActive }, idx)); }), _jsx(Spacer, {}), actions && _jsx(Flex, __assign({ align: "center" }, { children: actions }))] })));
};
export { SubNav };
